import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = {
  class: "card-header border-0 pt-6",
  style: {"position":"sticky","top":"45px","background-color":"white","z-index":"1"}
}
const _hoisted_3 = { class: "card-title flex-column flex-md-row align-items-stretch align-items-md-center gap-2" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_5 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_6 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_7 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_8 = { class: "card-toolbar" }
const _hoisted_9 = { class: "d-flex justify-content-end" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex justify-content-end align-items-center d-none",
  "data-kt-customer-table-toolbar": "selected"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder me-5" }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "me-2",
      "data-kt-customer-table-select": "selected_count"
    }),
    /*#__PURE__*/_createTextVNode("Selected ")
  ]),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-danger",
    "data-kt-customer-table-select": "delete_selected"
  }, " Delete Selected ")
], -1)
const _hoisted_11 = { style: {"width":"100%","margin-left":"5px"} }
const _hoisted_12 = { class: "table-responsive" }
const _hoisted_13 = { class: "table table-striped gy-5 gs-10" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bold fs-4 text-gray-800 border-bottom-2 border-gray-200" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-400px" }, "Ürünler"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-200px" }, "Kategori"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Fiyatı"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-400px" }, "Durumu"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px" }, "Birleştir / Sil")
  ])
], -1)
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = { class: "symbol symbol-60px symbol-2by3 me-4 flex-shrink-0" }
const _hoisted_17 = { class: "fw-bold text-gray-900 fs-6" }
const _hoisted_18 = { class: "fw-semibold text-gray-700 fs-7" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "d-flex flex-nowrap align-items-center" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-link" }, null, -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { class: "min-w-200px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control form-control-solid w-250px ps-14",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterparams) = $event)),
            placeholder: "Ürün Filtrele"
          }, null, 512), [
            [_vModelText, _ctx.filterparams]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
          ]),
          _createVNode(_component_Multiselect, {
            class: "ps-14",
            modelValue: _ctx.selectedCategory,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedCategory) = $event)),
            options: _ctx.categories,
            mode: "tags",
            searchable: true,
            locale: "tr",
            style: {"max-width":"400px"}
          }, null, 8, ["modelValue", "options"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-light-primary me-3",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.List = _ctx.PropList))
          }, " Tüm Ürünler "),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-light-primary me-3",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getCloseProducts()))
          }, " Kapalı Ürünler "),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-light-primary me-3",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getOpenProducts()))
          }, " Açık Ürünler ")
        ]),
        _hoisted_10
      ]),
      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.filtervaluem?.length ?? 0) + " Ürün bulundu ", 1)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("table", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.filtervaluem as ProductNGDTO[]), (item, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: index,
              class: "align-middle"
            }, [
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    (!item.HideImage)
                      ? (_openBlock(), _createBlock(_component_el_avatar, {
                          key: 0,
                          shape: "square",
                          size: 60,
                          fit: "cover",
                          class: "rounded",
                          src: _ctx.ProductNGDTO.imageUrl(item),
                          onError: ($event: any) => (item.HideImage = true)
                        }, null, 8, ["src", "onError"]))
                      : _createCommentVNode("", true),
                    (item.HideImage)
                      ? (_openBlock(), _createBlock(_component_el_avatar, {
                          key: 1,
                          shape: "square",
                          size: 60,
                          class: "rounded bg-light-primary fs-2 fw-bold text-primary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.ProductNGDTO.firstLetter(item)), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("span", _hoisted_17, _toDisplayString(item.name), 1)
                ])
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("span", _hoisted_18, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.integrationProducts, (iproduct, ix) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: ix }, [
                      _createTextVNode(_toDisplayString(_ctx.IntegrationProduct.twoLetter(iproduct)) + " : " + _toDisplayString(iproduct.product?.CategoryName) + " ", 1),
                      (
                        item.integrationProducts &&
                        ix < item.integrationProducts.length - 1
                      )
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _hoisted_19
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ])
              ]),
              _createElementVNode("td", {
                class: "fw-bold fs-6",
                style: _normalizeStyle(
                  _ctx.ProductNGDTO.priceEqual(item) ? 'color: black' : 'color: red'
                )
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.integrationProducts, (iproduct, ix) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: ix }, [
                    _createTextVNode(_toDisplayString(iproduct.product?.Price) + " ", 1),
                    (
                      item.integrationProducts &&
                      ix < item.integrationProducts.length - 1
                    )
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_20
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ], 4),
              _createElementVNode("td", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.integrationProducts, (iproduct, ix) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: ix,
                    onClick: ($event: any) => (
                      _ctx.changeStatusForIProduct(
                        iproduct,
                        iproduct.product?.Status == _ctx.ProductStatus.Open
                          ? _ctx.ProductStatus.DailyClosed
                          : _ctx.ProductStatus.Open
                      )
                    ),
                    style: _normalizeStyle(
                      iproduct?.product?.Status == _ctx.ProductStatus.Open
                        ? 'background-color: ' +
                          _ctx.IntegrationProduct.statusColor(
                            iproduct,
                            iproduct.product.Status
                          )
                        : 'background-color: gray'
                    ),
                    type: "button",
                    class: "btn btn-primary er fs-6 px-8 py-4"
                  }, _toDisplayString(_ctx.IntegrationProduct.firstLetter(iproduct)), 13, _hoisted_21))
                }), 128)),
                (
                    item.integrationProducts &&
                    item.integrationProducts.length > 1
                  )
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: ($event: any) => (
                    _ctx.changeStatusForAll(
                      item,
                      _ctx.ProductNGDTO.isThereAnyOpen(item)
                        ? _ctx.ProductStatus.Closed
                        : _ctx.ProductStatus.Open
                    )
                  ),
                      style: {"background-color":"green","margin-left":"2px"},
                      type: "button",
                      class: "btn btn-primary er fs-6 px-8 py-4"
                    }, _toDisplayString(_ctx.ProductNGDTO.isThereAnyOpen(item)
                      ? "Tümünü Kapat"
                      : "Tümünü Aç"), 9, _hoisted_22))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("button", {
                    class: "btn btn-icon btn-bg-light btn-active-color-primary",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#ModalPopUp",
                    id: "kt_toolbar_primary_button",
                    title: "Birleştir",
                    onClick: ($event: any) => {
                      _ctx.SelectedProduct = item;
                      _ctx.deleteitem(index);
                    }
                  }, _hoisted_26, 8, _hoisted_24),
                  (item.mergedProduct && item.mergedProduct.id)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-icon btn-light-danger ms-2",
                        title: "Ürünü sil",
                        onClick: ($event: any) => (_ctx.deleteMerged(item))
                      }, _hoisted_29, 8, _hoisted_27))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          }), 128)),
          _createElementVNode("th", _hoisted_30, [
            false
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.undocombine())),
                  type: "button",
                  class: "btn btn-primary"
                }, " Birleştirmeleri Sıfırla "))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_popup, {
            Valuem: _ctx.popupList,
            "onUpdate:Valuem": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.popupList) = $event)),
            ValuemModifiers: { sync: true },
            SelectedProduct: _ctx.SelectedProduct,
            "onUpdate:SelectedProduct": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.SelectedProduct) = $event)),
            SelectedProductModifiers: { sync: true },
            Indexes: _ctx.indexes,
            "onUpdate:Indexes": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.indexes) = $event)),
            IndexesModifiers: { sync: true },
            onSaved: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('need-refresh')))
          }, null, 8, ["Valuem", "SelectedProduct", "Indexes"])
        ])
      ])
    ])
  ]))
}